import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import SEO from "../components/SEO";
import PostList from "../components/Blog/PostList";
import { Header } from "../components/Acf/Header";
import { decodeEntities } from "../utils/helpers";
import Layout from "../components/Layout";
import { GlobalCta } from "../components/Acf/GlobalCta";

const Category = (props) => {
  const { data, pageContext, location } = props;
  const {
    postsOnPage,
    categoryFilter,
    categories,
    site,
    wordpressWpSettings,
    yoast = [],
    siteSettings,
  } = data;
  const { wordpressUrl } = wordpressWpSettings;
  const { showAuthor, customCss } = siteSettings.options;
  const { edges: posts, totalCount } = postsOnPage;
  const { title: siteTitle, date_format } = wordpressWpSettings;
  const { name: category, slug, pathPrefix } = pageContext;
  const title = `${category} Category`;
  const thisCategory = categories.edges.filter((i) => i.node.slug === slug);

  return (
    <Layout
      className="posts-archive"
      location={location}
      wordpressUrl={wordpressUrl}
      theme={"light"}
    >
      <SEO
        title={`${decodeEntities(category)} | ${decodeEntities(siteTitle)}`}
        yoast={yoast}
        location={location}
      />
      <Header title="News" theme="light" />
      <PostList
        posts={posts}
        title={title}
        pageContext={pageContext}
        categoryFilter={categoryFilter}
        siteMetadata={wordpressWpSettings}
        pathPrefix={`/category/${slug}/`}
        showAuthor={showAuthor}
        dateFormat={date_format}
      />
      <GlobalCta
        custom
        content={`<p><span class="h2">Contact us so we can help you today.</span></p>`}
        link={{ url: `/contact-us/`, title: `Contact Us` }}
      />
    </Layout>
  );
};

export default Category;

export const pageQuery = graphql`
  query CategoryPage($slug: String!, $limit: Int!, $skip: Int!) {
    wordpressWpSettings {
      title
      blogSlug
      wordpressUrl
      siteUrl
      date_format
    }
    siteSettings: wordpressAcfOptions {
      options {
        showAuthor
        customCss
      }
    }
    categoryFilter: allWordpressPost {
      nodes {
        categories {
          wordpress_id
          id
          name
          slug
          path
          id
        }
      }
    }
    postsOnPage: allWordpressPost(
      filter: {
        categories: { elemMatch: { slug: { eq: $slug } } }
        slug: { ne: "dummy-post" }
      }
      sort: { fields: date, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          ...PostListFields
        }
      }
    }
    categories: allWordpressCategory(filter: { count: { gt: 0 } }) {
      edges {
        node {
          name
          slug
          featured_media {
            localFile {
              childImageSharp {
                fluid(maxWidth: 670, quality: 70) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
          }
          count
        }
      }
    }
  }
`;
